import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { deleteAuthUser } from '../../../redux/reducer/authUserSlice';
// import { clearPermission } from '../../../redux/reducer/permissionSlice';
import { logoutService } from '../../../utils/services/auth.service';
import { showSnackbar } from '../../../redux/reducer/snackbarSlice';
import { clearPermissionState } from '../../../redux/reducer/permissionSlice';
import useAuthUser from '../../../hooks/useAuthUser';

const LogoutPage = () => {
    const dispatch = useDispatch();
    const { token } =useAuthUser()
    useEffect(() => {
        handleLogout();
    }, []);

    const handleLogout = async () => {
        const { code, message } = await logoutService({ Authorization:token })
        if (code === 200) {
            dispatch(showSnackbar({ message, type: 'success' }))
        } else {
            dispatch(showSnackbar({ message, type: 'error' }))
        }
        localStorage.clear();
        sessionStorage.clear();
        dispatch(deleteAuthUser());
        dispatch(clearPermissionState())
        window.open("/auth/login", "_self");
       
    }
    return null;
};

export default LogoutPage;
